import { LogOut } from "lucide-react";

const getUserInitials = (fullName) => {
  if (!fullName) return "SA";
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

const formatRole = (role) => {
  if (!role) return "Administrator";
  const text = typeof role === "string" ? role : String(role);
  return text.charAt(0).toUpperCase() + text.slice(1).replace(/_/g, " ");
};

const SidebarUserCard = ({ user, onLogout }) => (
  <div className="sq-user-card">
    <span className="sq-user-avatar" aria-hidden="true">
      {getUserInitials(user?.full_name)}
    </span>
    <span className="sq-user-copy">
      <b>{user?.full_name || "System Administrator"}</b>
      <span>{formatRole(user?.role)}</span>
    </span>
    <button type="button" className="sq-logout-btn" onClick={onLogout} title="Sign out" aria-label="Sign out">
      <LogOut strokeWidth={2} width={16} height={16} />
    </button>
  </div>
);

export default SidebarUserCard;
